import React from 'react';
import ReactDOM from 'react-dom/client';
import './one-trust-cookies';
import './polyfills';
import './disclosure-analytics';
import './walkme-bootstrap';
import './adobe-analytics-bootstrap';
import 'styles/base-styles.scss';

import App from 'components/app-component';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
